import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import type { IApiClient } from '../api/IApiClient'

const ApiContext = createContext<IApiClient | null>(null)

export function ApiProvider({
  client,
  children,
}: {
  client: IApiClient
  children: ReactNode
}) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>
}

export function useApi(): IApiClient {
  const client = useContext(ApiContext)
  if (!client) {
    throw new Error('useApi() called outside <ApiProvider>. Wrap your app in <ApiProvider client={...}>.')
  }
  return client
}
